import Vue from 'vue'
import * as svgicon from 'vue-svgicon'

Vue.use(svgicon)
